<style scoped>
</style>

<template>
  <div class="border-bottom border-1 border-dark py-1 ps-2 text-black bg-white">
    <h1>MHRiseクエ貼りツール {{mode}}</h1>
    <a class="ms-2 ext-link" target="_blank" href="https://scrapbox.io/mhrise-queque/README">説明書</a>
    <a class="ms-2 ext-link" target="_blank" href="https://scrapbox.io/mhrise-queque/history">更新履歴</a>
  </div>
</template>

<script>
export default {
  computed: {
    mode() {
      return process.env.VUE_APP_MODE ?? ''
    }
  },
}
</script>
